import axios from "axios";
import moment from "moment-timezone";

let otaBaseUrl = `${process.env.VUE_APP_CONFIG_OTA_BASEURL}`;
let token = `${process.env.VUE_APP_CONFIG_OTA_TOKEN}`;
let otaConfig = {
	baseURL: otaBaseUrl,
	headers: {
		"Access-Control-Allow-Origin": "*",
		"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
		"X-User-Token": token,
	},
	//withCredentials: true,
};
const axiosClient = axios.create(otaConfig);

const otaDateMiddleware = (timezone, date) => {
	// console.log(timezone, date);
	let year_set = false;
	date = date.split(",");

	if (date.length === 1) {
		date = date[0];
		date = date.split(" ");
		year_set = true;
	}
	if (date.length === 1) {
		date = date[0];
		date = date.split("T");
		year_set = true;
	}
	if (date.length === 1) {
		return date[0];
	}

	// determine what year to add to the date * REQUIRED for Firefox *
	let currentYear = new Date().getFullYear();
	let time = date[1].trim();
	let tempDate = date[0].trim();
	if (!year_set) {
		let useCurrentYear = new Date().getTime() >= new Date(tempDate + ", " + new Date().getFullYear()).getTime();
		if (useCurrentYear) {
			date = tempDate + ", " + currentYear + " " + time;
		} else {
			date = tempDate + ", " + (currentYear - 1) + " " + time;
		}
	} else {
		date = tempDate + "T" + time;
	}
	// console.log(date);
	date = new Date(date);
	// console.log("DATE OBJ", timezone, date);

	// browser timezone conversion
	let isoDate = moment(date).toISOString();
	let sourceDate = moment.tz(isoDate, timezone);
	let localDate = sourceDate.local();

	let formatted_date = localDate.format("MMM DD, YYYY hh:mm A");

	let userTimezone = moment.tz.guess();
	let tzAbbr = moment.tz.zone(userTimezone).abbr(localDate);

	// console.log(tzAbbr);
	// console.log(userTimezone);
	// console.log(timezone, date, '=>', formatted_date + " " + timezoneAbbreviations[userTimezone]);

	return formatted_date + " " + tzAbbr;
};

const otaDashboardService = {
	async getUserCheck() {
		let url = `/user/check`;
		return axiosClient.post(url);
	},
	async getUsersList(data) {
		let url = `users/list`;
		return axiosClient.post(url, data);
	},
	async createToken(data) {
		let url = `users/token_create`;
		return axiosClient.post(url, data);
	},
	async revokeToken(data) {
		let url = `users/token_revoke`;
		return axiosClient.post(url, data);
	},
	async modifyUser(data) {
		let url = `users/modify`;
		return axiosClient.post(url, data);
	},
	async createNewUser(data) {
		let url = `users/add`;
		return axiosClient.post(url, data);
	},
	async saveCarrier(data) {
		let url = `carriers/modify`;
		return axiosClient.post(url, data);
	},
	async listIccidRanges(data) {
		let url = `ranges/list`;
		return axiosClient.post(url, data);
	},
	async addIccidRange(data) {
		let url = `ranges/add`;
		return axiosClient.post(url, data);
	},
	async editIccidRange(data) {
		let url = `ranges/edit`;
		return axiosClient.post(url, data);
	},
	async disableIccidRange(data) {
		let url = `ranges/disable`;
		return axiosClient.post(url, data);
	},
	async deleteIccidRange(data) {
		let url = `ranges/delete`;
		return axiosClient.post(url, data);
	},
	async getCarrierFiles(data) {
		let url = `files/get`;
		return axiosClient.post(url, data);
	},
	async addCarrierFile(data) {
		let url = `files/add`;
		return axiosClient.post(url, data);
	},
	async editCarrierFile(data) {
		let url = `files/edit`;
		return axiosClient.post(url, data);
	},
	async removeCarrierFile(data) {
		let url = `files/delete`;
		return axiosClient.post(url, data);
	},
	async getCarrierFileInfo(data) {
		let url = `files/info`;
		return axiosClient.post(url, data).then(res => {
			// console.log(res);
			try {
				if (res.data.error_string) {
					throw new Error(res.data.error_string);
				}
				let timezone = res.data.timezone;
				let file_info = res.data.result;
				if (file_info) {
					let new_file_info = {
						...file_info,
						date: {
							modified: otaDateMiddleware(timezone, file_info.date.modified),
						},
					};
					res.data.result = new_file_info;
				}

				return res;
			} catch (e) {
				if (process.env.NODE_ENV === "dev") {
					console.error(e);
				}
				return res;
			}
		});
	},
	async downloadCarrierFile(data) {
		let url = `files/download`;
		// return axiosClient.post(url, data);
		return axios({
			url: `${otaBaseUrl}${url}`,
			method: "POST",
			responseType: "blob", // important
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
				"X-User-Token": token,
			},
			data: data,
		}).then(response => {
			const blob = new Blob([response.data]);
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = `${data.carrier}_${data.name}_${data.type}.dat`;
			// link.download = `${data.name}.dat`
			link.click();
			URL.revokeObjectURL(link.href); // for firefox
		});
	},
	async disableCarrierFile(data) {
		let url = `files/disable`;
		return axiosClient.post(url, data);
	},
	async disableCarrier(data) {
		let url = `carriers/disable`;
		return axiosClient.post(url, data);
	},
	async removeCarrier(data) {
		let url = `carriers/remove`;
		return axiosClient.post(url, data);
	},
	async addCarrier(data) {
		let url = `/carriers/add`;
		return axiosClient.post(url, data);
	},
	async getCarriers(data) {
		if (!data || data === "") data = {add: 1, files: 1};
		let url = `carriers/list`;
		return axiosClient.post(url, data);
	},
	async getCarriersList(data) {
		//same as getCarriers
		if (!data || data === "") data = {add: 1, files: 1};
		let url = `carriers/list`;
		return axiosClient.post(url, data);
	},
	async getVendors() {
		let url = `vendors/list`;
		return axiosClient.post(url);
	},
	async inventory(data) {
		let url = `inventory/list`;
		return axiosClient.post(url, data).then(res => {
			// console.log(res.data);
			try {
				if (res.data.error_string) {
					throw new Error(res.data.error_string);
				}
				let timezone = res.data.timezone;
				let inventory_items = res.data.result.inventory;
				let new_inventory_items = [];
				if (inventory_items.length > 0) {
					inventory_items.map(item => {
						let new_item = structuredClone(item);
						if (item.hasOwnProperty("minutes_ago")) {
							let dateString = new Date(Date.now() - item.minutes_ago * 60000);
							dateString = moment(dateString).format("MMM DD, hh:mm A");
							// console.log(dateString);
							new_item.date = otaDateMiddleware(timezone, dateString);
						}
						new_inventory_items.push(new_item);
					});
					// console.log(new_inventory_items);
					res.data.result.inventory = new_inventory_items;
					return res;
				}
			} catch (e) {
				console.error(e);
				return res;
			}
		});
	},

	async activate(data) {
		let url = `ota/activate`;
		if (process.env.VUE_APP_CLIENT !== "execulink") {
			otaBaseUrl = otaBaseUrl.replace("_v2", "").replace("_v3", "");
			let config = {
				baseURL: otaBaseUrl,
				headers: {
					"Access-Control-Allow-Origin": "*",
					"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
					"X-User-Token": token,
				},
				//withCredentials: true,
			};
			const client = axios.create(config);
			return client.post(url, data);
		} else {
			return axiosClient.post(url, data);
		}
	},

	async inventory_add(data) {
		let url = `inventory/add`;
		return axiosClient.post(url, data);
		// let url = `ota/activate`;
		// let otaConfig = {
		// 	baseURL: 'https://services.dccllc.net/ota/api/',
		// 	headers: {
		// 		"Access-Control-Allow-Origin": "*",
		// 		"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
		// 		"X-User-Token": token,
		// 	},
		// };
		//  let axiosClientOld = axios.create(otaConfig);
		// return axiosClientOld.post(url, data);
	},

	async inventory_check(iccid) {
		let url = `inventory/rangecheck`;
		let data = {
			iccid: iccid,
		};
		return axiosClient.post(url, data);
	},

	async inventory_delete(iccid) {
		let url = `inventory/delete`;
		let data = {
			iccid: iccid,
		};
		return axiosClient.post(url, data);
	},

	async activate_simple(iccid, msisdn, mdn, min, eprl, oplmn, fplmn, smsota, force = 0) {
		//TODO: remap this one.
		let url = `ota/activate`;
		let data = {
			type: "ota",
			method: "activate",
			force: force,
			iccid: iccid,
		};
		if (msisdn && String(msisdn).length > 1) data.msisdn = msisdn;
		if (mdn && String(mdn).length > 1) data.mdn = mdn;
		if (min && String(min).length > 1) data.min = min;
		if (eprl && String(eprl).length > 1) data.eprl = eprl;
		if (oplmn && String(oplmn).length > 1) data.oplmn = oplmn;
		if (fplmn && String(fplmn).length > 1) data.fplmn = fplmn;
		if (smsota && String(oplmn).length > 1) data.smsota = smsota;
		return axiosClient.post(url, data);
	},

	async getProfile(iccid) {
		let url = `ota/profile`;
		let data = {
			iccid: iccid,
		};
		return axiosClient.post(url, data).then(res => {
			// console.log(res.data);
			try {
				if (res.data.error_string) {
					throw new Error(res.data.error_string);
				} else if (res.data.result === false) {
					return res;
				}
				let timezone = res.data.timezone;
				let profile_items = res.data.result;
				let dateKeys = ["lastotatime", "lastqueriedtime", "lastupdatetime", "inserttime"];

				for (const key in profile_items) {
					if (dateKeys.includes(key) && profile_items[key]) {
						// console.log(key.toString(), profile_items[key]);
						if (profile_items[key].includes("0000-00-00")) continue;
						// console.log(new Date(profile_items[key]).toISOString());
						dateKeys.splice(dateKeys.indexOf(key), 1);
						profile_items[key] = otaDateMiddleware(timezone, new Date(profile_items[key]).toISOString());
					}
				}

				if (dateKeys.length > 0) {
					dateKeys.forEach(key => {
						profile_items[key] = "Never";
					});
				}
				res.data.result = profile_items;
				return res;
			} catch (e) {
				console.error(e);
				return res;
			}
		});
	},

	async getProfileLogs(iccid) {
		let url = `ota/logs`;
		let data = {
			iccid: iccid,
		};
		return axiosClient.post(url, data).then(res => {
			// console.log(res.data);
			try {
				if (res.data.error_string) {
					let error = res.data.error_string;
					if (!error.includes("No logs found")) {
						throw new Error(res.data.error_string);
					} else {
						return res;
					}
				}
				let timezone = res.data.timezone;
				let log_items = res.data.result.logs;
				log_items = log_items.map(item => {
					let new_item = structuredClone(item);
					if (item.hasOwnProperty("date")) {
						new_item.date = otaDateMiddleware(timezone, item.date);
					}
					if (item.hasOwnProperty("start")) {
						new_item.start = otaDateMiddleware(timezone, item.start);
					}
					if (item.hasOwnProperty("end")) {
						new_item.end = otaDateMiddleware(timezone, item.end);
					}
					return new_item;
				});
				res.data.result.logs = log_items;
				return res;
			} catch (e) {
				if (process.env.NODE_ENV !== "production") {
					console.error(e);
				}
				return res;
			}
		});
	},

	async query(iccid, log, minimal) {
		if (!log || log === "undefined") log = 0;
		if (!minimal || minimal === "undefined" || minimal < 1) {
			let url = `ota/query`;
			let data = {
				type: "ota",
				method: "query",
				log_from: log,
				iccid: iccid,
			};
			return axiosClient.post(url, data).then(res => {
				try {
					if (res.data.error_string) {
						throw new Error(res.data.error_string);
					}
					// console.log(res.data.result);
					let timezone = res.data.timezone;
					let log_items = res.data.result.log_items;
					let new_log_items = [];
					if (log_items.length > 0) {
						log_items.forEach(item => {
							let new_item = {};
							if (item.date) {
								// console.log("item.date", item.date);
								new_item = {
									...item,
									date: otaDateMiddleware(timezone, item.date),
								};
							} else {
								// console.log("item.start", item.start);
								new_item = {
									...item,
									start: otaDateMiddleware(timezone, item.start),
									end: otaDateMiddleware(timezone, item.end),
								};
							}
							new_log_items.push(new_item);
						});
						// console.log(new_log_items);
						res.data.result.log_items = new_log_items;
					}

					let dateKeys = ["lastotatime", "lastqueriedtime", "lastupdatetime"];
					let temp = res.data.result.items.data;
					for (const key in temp) {
						if (dateKeys.includes(key) && temp[key]) {
							// console.log(key.toString(), temp[key]);
							temp[key] = otaDateMiddleware(timezone, temp[key]);
						}
					}

					return res;
				} catch (e) {
					console.error(e);
					return res;
				}
			});
		} else {
			return this.query_minimal(iccid);
		}
	},

	async query_minimal(iccid) {
		let url = `ota/query_minimal`;
		let data = {iccid: iccid};

		if (process.env.VUE_APP_CLIENT !== "execulink") {
			otaBaseUrl = otaBaseUrl.replace("_v2", "").replace("_v3", "");
			let config = {
				baseURL: otaBaseUrl,
				headers: {
					"Access-Control-Allow-Origin": "*",
					"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
					"X-User-Token": token,
				},
				//withCredentials: true,
			};
			const client = axios.create(config);
			return client.post(url, data);
		} else {
			return axiosClient.post(url, data);
		}
	},

	async exists(iccid) {
		let url = `ota/exists`;
		let data = {iccid: iccid};
		return axiosClient.post(url, data);
	},

	async reset(iccid) {
		let url = `ota/reset`;
		let data = {iccid: iccid};
		//return axiosClient.post(url, data);

		if (process.env.VUE_APP_CLIENT !== "execulink") {
			otaBaseUrl = otaBaseUrl.replace("_v2", "").replace("_v3", "");
			let config = {
				baseURL: otaBaseUrl,
				headers: {
					"Access-Control-Allow-Origin": "*",
					"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
					"X-User-Token": token,
				},
				//withCredentials: true,
			};
			const client = axios.create(config);
			return client.post(url, data);
		} else {
			return axiosClient.post(url, data);
		}
	},

	async enable(iccid) {
		let url = `ota/enable`;
		let data = {iccid: iccid};
		return axiosClient.post(url, data);
	},

	async disable(iccid, reason) {
		let url = `ota/disable`;
		let data = {iccid: iccid, reason: reason};
		return axiosClient.post(url, data);
	},

	async trigger(iccid) {
		let url = `ota/trigger`;
		let data = {iccid: iccid};
		return axiosClient.post(url, data);
	},

	async transfer(from, to, reason) {
		let url = `ota/transfer`;
		let data = {
			from: from,
			to: to,
			reason: reason,
		};
		return axiosClient.post(url, data);
	},

	async reissue(filter) {
		let data = {filter: filter};
		let url = `ota/reissue`;
		return axiosClient.post(url, data);
	},

	async otaReport(carrier, start_date, end_date, detail) {
		let url = `reports/provisioning_history`;
		let data = {
			carrier,
			start_date,
			end_date,
			detail,
		};
		return axiosClient.post(url, data).then(res => {
			// console.log(res);
			try {
				if (res.data.error_string) {
					throw new Error(res.data.error_string);
				}
				let timezone = res.data.timezone;
				let new_report_items = [];
				let report_items = res.data.result.report_data;
				if (detail > 0 && report_items.length > 0) {
					report_items.forEach(item => {
						let new_item = {
							...item,
							date: otaDateMiddleware(timezone, item.date),
						};
						new_report_items.push(new_item);
					});
					res.data.result.report_data = new_report_items;
				}
				return res;
			} catch (e) {
				console.error(e);
				return res;
			}
		});
	},

	async removeUser(payload) {
		let url = "users/remove";
		return axiosClient.post(url, payload);
	},

	async disableUser(payload) {
		let url = "users/disable";
		return axiosClient.post(url, payload);
	},
};

export default otaDashboardService;
